import { render, staticRenderFns } from "./PublishTechDemand.vue?vue&type=template&id=55c64720&scoped=true"
import script from "./PublishTechDemand.vue?vue&type=script&lang=js"
export * from "./PublishTechDemand.vue?vue&type=script&lang=js"
import style0 from "./PublishTechDemand.vue?vue&type=style&index=0&id=55c64720&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c64720",
  null
  
)

export default component.exports